import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconComputerUse: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="computer-use, cursor"><path fillRule="evenodd" clipRule="evenodd" d="M19.25 3C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H19.25ZM9.00195 7.7373C8.22025 7.4768 7.4768 8.22025 7.7373 9.00195L10.1465 16.2295C10.4596 17.1677 11.7993 17.1302 12.0596 16.1758L12.8662 13.2178C12.9128 13.047 13.047 12.9128 13.2178 12.8662L16.1758 12.0596C17.1302 11.7993 17.1677 10.4596 16.2295 10.1465L9.00195 7.7373Z" fill="currentColor"/></CentralIconBase>;
};

export default IconComputerUse;
